//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod

const DeleteBillingInformation = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteBillingInformation,
        method: RequestType.DELETE,
        data,
    });
const PostGetBillingInformation = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PostGetBillingInformation,
        method: RequestType.POST,
        data,
    });
const UpdateBillingInformation = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateBillingInformation,
        method: RequestType.PUT,
        data,
    });
const CreateReports = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CreateReportsListItem,
        method: RequestType.POST,
        data,
    });
const DeleteReports = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteReportListItem + '/' + data,
        method: RequestType.DELETE,
    });
const UpdateReportsListItem = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateReportsListItem,
        method: RequestType.PUT,
        data,
    });
const UpdateAuthByRole = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateAuthByRole,
        method: RequestType.POST,
        data,
    });

const GetExpenseBill = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetExpenseBill,
        method: RequestType.POST,
        data,
        responseType: 'blob',
    });

const ReportsCommand = {
    DeleteBillingInformation,
    PostGetBillingInformation,
    UpdateBillingInformation,
    CreateReports,
    DeleteReports,
    UpdateReportsListItem,
    UpdateAuthByRole,
    GetExpenseBill,
};

export default ReportsCommand;
